import {buildGroupPayload} from './filters';

/**
 * Inline "Filter Criteria" bar on each dashboard report/chart. Ad-hoc only for v1:
 * nothing here is persisted, it just overrides the chart's Default Filter
 * (chart->filter_id) for the current view. Reuses the existing filter-builder
 * condition-row markup/handlers from filters.js (.criteria-field/.criteria-condition
 * cascading, .add-criteria/.remove-criteria) - this file only wires the
 * open/seed/apply/clear behavior specific to the dashboard.
 */
$(document).ready(function (e) {
    if (!$('.charts').length) {
        return;
    }

    let $body = $('body');

    /**
     * Reflect the bar's AND/OR state in the header toggle + subtitle. Rows can still be
     * toggled one by one via their own .query-by label, so a mixed set leaves neither
     * toggle button active.
     */
    function syncHeader($bar) {
        let $queryBy = $bar.find('.query-by'),
            modes = $queryBy.map((i, el) => $(el).attr('data-query-by')).get()
                .filter((value, i, all) => all.indexOf(value) === i),
            mode = modes.length === 1 ? modes[0] : (modes.length ? null : ($bar.data('mode') || 'AND')),
            count = $bar.find('.single-criteria').length,
            $buttons = $bar.find('.chart-filter-mode-btn'),
            modeText = mode
                ? $buttons.filter(`[data-mode="${mode}"]`).text().trim()
                : $buttons.map((i, el) => $(el).text().trim()).get().join(' / ');

        $buttons.removeClass('active');
        if (mode) {
            $buttons.filter(`[data-mode="${mode}"]`).addClass('active');
        }

        $bar.find('.chart-filter-subtitle').text(`${$bar.attr('data-conditions-label')}: ${count} · ${modeText}`);
    }

    function setQueryBy($elements, mode) {
        $elements.each((i, el) => {
            let $el = $(el);

            $el.attr('data-query-by', mode)
                .text(mode === 'AND' ? $el.attr('data-and-translation') : $el.attr('data-or-translation'));
        });
    }

    // Rows are inserted by the shared filters.js handlers (add/remove condition), so watch
    // the container instead of hooking each of them: new rows follow the header's AND/OR.
    $('.chart-filter-bar').each((i, bar) => {
        let $bar = $(bar);

        new MutationObserver(() => {
            let mode = $bar.data('mode');

            if (mode) {
                setQueryBy($bar.find(`.query-by:not([data-query-by="${mode}"])`), mode);
            }

            syncHeader($bar);
        }).observe($bar.find('.chart-filter-groups')[0], {childList: true, subtree: true});
    });

    $body.on('click', '.chart-filter-mode-btn', function (e) {
        e.preventDefault();
        let $bar = $(this).parents('.chart-filter-bar'),
            mode = $(this).attr('data-mode');

        $bar.data('mode', mode);
        setQueryBy($bar.find('.query-by'), mode);
        syncHeader($bar);
    });

    // A per-row toggle (handled in filters.js) means the header no longer dictates the mode.
    $body.on('click', '.chart-filter-bar .query-by', function (e) {
        let $bar = $(this).parents('.chart-filter-bar');

        $bar.removeData('mode');
        setTimeout(() => syncHeader($bar));
    });

    $body.on('click', '.chart-filter-add-condition', function (e) {
        e.preventDefault();
        $(this).parents('.chart-filter-bar').find('.add-criteria').last().trigger('click');
    });

    function addBlankRow($bar) {
        let table_id = $bar.attr('data-table-id');

        $.ajax({
            type: 'GET',
            url: `/filter/${table_id}/group`,
            data: {
                showGroupQuery: 0
            },
            success: (res) => {
                $bar.find('.chart-filter-groups').html(res);
                $bar.find('.remove-criteria-group').addClass('d-none');
                $('.selectpicker').selectpicker({
                    noneSelectedText: translation.nothing_selected
                });
            }
        });
    }

    $body.on('click', '.toggle-chart-filter-bar', function (e) {
        e.preventDefault();
        let chart_id = $(this).data('id'),
            $bar = $(this).parents('.chart').find('.chart-filter-bar[data-chart-id="' + chart_id + '"]');

        $bar.toggleClass('d-none');

        if (!$bar.hasClass('d-none') && !$bar.find('.criteria-group').length) {
            let table_id = $bar.attr('data-table-id'),
                filter_id = $bar.attr('data-default-filter-id');

            if (filter_id) {
                $.ajax({
                    type: 'GET',
                    url: `/filter/${table_id}/${filter_id}/criteria`,
                    success: (res) => {
                        $bar.find('.chart-filter-groups').html(res);
                        $bar.find('.remove-criteria-group').addClass('d-none');
                        $('.selectpicker').selectpicker({
                            noneSelectedText: translation.nothing_selected
                        });
                    }
                });
            } else {
                addBlankRow($bar);
            }
        }
    });

    $body.on('click', '.apply-chart-filter', function (e) {
        e.preventDefault();
        let $bar = $(this).parents('.chart-filter-bar'),
            chart_id = $bar.attr('data-chart-id'),
            $groups = $bar.find('.criteria-group'),
            {group_payload, error} = buildGroupPayload($groups);

        if (error) {
            return;
        }

        let non_empty_groups = group_payload.filter((group) => group.payload.length);

        window.redrawDashboardChart(chart_id, non_empty_groups.length ? non_empty_groups : false);
        $(`.toggle-chart-filter-bar[data-id="${chart_id}"]`).toggleClass('active', !!non_empty_groups.length);
    });

    $body.on('click', '.clear-chart-filter', function (e) {
        e.preventDefault();
        let $bar = $(this).parents('.chart-filter-bar'),
            chart_id = $bar.attr('data-chart-id');

        addBlankRow($bar);

        window.redrawDashboardChart(chart_id, false);
        $(`.toggle-chart-filter-bar[data-id="${chart_id}"]`).removeClass('active');
    });
});
